export default function AppTrackingCodes() {
	const isProd = process.env.NODE_ENV === 'production';

	if (!isProd) return null;

	return (
		<>
			{/* Usercentrics */}
			<script
				id="usercentrics-cmp"
				async
				src="https://web.cmp.usercentrics.eu/ui/loader.js"
				data-settings-id="f4-WONgpaLN8BL"
			/>

			{/* Google Tag Manager – consent-gated */}
			<script
				type="text/plain"
				data-usercentrics="Google Tag Manager"
				dangerouslySetInnerHTML={{
					__html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-T8S2MPF7');
          `,
				}}
			/>

			{/* Contentsquare */}
			<script
				type="text/plain"
				data-usercentrics="ContentSquare"
				src="https://t.contentsquare.net/uxa/4ca0423c5f773.js"
			/>

			{/* Facebook Pixel */}
			<script
				type="text/plain"
				data-usercentrics="Facebook Pixel"
				dangerouslySetInnerHTML={{
					__html: `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					n.queue=[];t=b.createElement(e);t.async=!0;
					t.src=v;s=b.getElementsByTagName(e)[0];
					s.parentNode.insertBefore(t,s)}(window,document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '344909229387568');
				fbq('track', 'PageView'); `,
				}}
			/>
		</>
	);
}
